import { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

const employeeLinks = [
  { to: '/', label: 'Panel', icon: '📊', end: true },
  { to: '/insumos', label: 'Insumos', icon: '🌿' },
  { to: '/inventario', label: 'Inventario', icon: '📦' },
  { to: '/recetas', label: 'Arreglos', icon: '💐' },
  { to: '/ventas', label: 'Registro de venta', icon: '🧾' },
  { to: '/cotizaciones', label: 'Cotizaciones', icon: '📝' },
];

const adminLinks = [
  { to: '/historial', label: 'Historia de ventas', icon: '🕒' },
  { to: '/admin/usuarios', label: 'Usuarios', icon: '👤' },
  { to: '/admin/formato-cotizacion', label: 'Formato de cotización', icon: '🖨️' },
  { to: '/admin/categorias', label: 'Categorias', icon: '🏷️' },
  { to: '/admin/unidades', label: 'Unidades', icon: '📐' },
  { to: '/admin/configuracion', label: 'Merma global', icon: '⚙️' },
];

export function Layout() {
  const { user, logout } = useAuth();
  const { notify } = useToast();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  async function handleLogout() {
    try {
      await logout();
      notify('Sesion cerrada correctamente.', 'success');
      navigate('/login', { replace: true });
    } catch {
      notify('No fue posible cerrar la sesion.', 'error');
    }
  }

  return (
    <div className="app-shell">
      <a href="#main-content" className="skip-link">
        Saltar al contenido principal
      </a>
      <div className={`sidebar-backdrop ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(false)} />
      <aside className={`sidebar ${menuOpen ? 'open' : ''}`} aria-label="Navegacion principal">
        <div className="sidebar-brand">
          <span className="brand-mark" aria-hidden="true">FS</span>
          <span className="brand-lockup">
            FLOWERSOFT
            <small>Gestión inteligente para floristerías</small>
          </span>
        </div>
        <nav>
          <div className="sidebar-section-title">Operacion</div>
          {employeeLinks.map((link) => (
            <NavLink key={link.to} to={link.to} end={link.end} onClick={() => setMenuOpen(false)} className={({ isActive }) => (isActive ? 'active' : '')}>
              <span aria-hidden="true">{link.icon}</span> {link.label}
            </NavLink>
          ))}
          {user?.role === 'ADMIN' && (
            <>
              <div className="sidebar-section-title">Administracion</div>
              {adminLinks.map((link) => (
                <NavLink key={link.to} to={link.to} onClick={() => setMenuOpen(false)} className={({ isActive }) => (isActive ? 'active' : '')}>
                  <span aria-hidden="true">{link.icon}</span> {link.label}
                </NavLink>
              ))}
            </>
          )}
        </nav>
      </aside>
      <div className="main-area">
        <header className="topbar">
          <div className="flex gap-sm" style={{ alignItems: 'center' }}>
            <button
              type="button"
              className="mobile-menu-toggle"
              aria-label="Abrir menu de navegacion"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((v) => !v)}
            >
              ☰
            </button>
            {user?.branch && (
              <div className="topbar-branch">
                <strong>{user.branch.companyName}</strong>
                <span>{user.branch.name}</span>
              </div>
            )}
          </div>
          <div className="topbar-user">
            <span className="badge-role">{user?.role === 'ADMIN' ? 'Administrador' : 'Empleado'}</span>
            <span>{user?.fullName}</span>
            <NavLink to="/perfil" className="btn btn-secondary btn-sm">
              Mi cuenta
            </NavLink>
            <button type="button" className="btn btn-secondary btn-sm" onClick={handleLogout}>
              Cerrar sesion
            </button>
          </div>
        </header>
        <main id="main-content" className="page-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
